import {InfiniteData, useMutation, useQueryClient} from '@tanstack/react-query'
import {unsaveGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'
import {GoalV3} from '@/features/chat/chat.model'
import {ResponseActiveGoalsList} from '../types'

export const useUnsaveGoalV3 = (goalId: string) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => unsaveGoal(goalId),
        onSuccess: () => {
            queryClient.setQueriesData(
                {queryKey: [QUERY_KEYS.goals_list]},
                (oldDate: InfiniteData<ResponseActiveGoalsList> | undefined) => {
                    if (!oldDate) return oldDate
                    return {
                        ...oldDate,
                        pages: oldDate.pages.map(page => ({
                            ...page,
                            data: page.data.map(goal =>
                                goal.id.toString() === goalId ? {...goal, is_saved: false} : goal
                            )
                        }))
                    }
                }
            )
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, goalId]}, (oldGoal: GoalV3 | undefined) => {
                if (!oldGoal) {
                    queryClient.invalidateQueries({queryKey: [QUERY_KEYS.selectedGoal, goalId]})
                    return undefined
                }
                return {
                    ...oldGoal,
                    isSaved: false
                }
            })
        }
    })
}
